export default "__VITE_ASSET__DCgFzhl8__"